<p-dialog
  [(visible)]="visible"
  [header]="dialogData.header"
  [modal]="true"
  [closable]="!isLoading"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '450px' }"
  (onHide)="onDialogHide()"
>
  <div class="flex align-items-center gap-3 mb-3">
    <i
      *ngIf="dialogData.icon"
      [class]="dialogData.icon"
      style="font-size: 2rem"
    >
    </i>
    <span>{{ dialogData.message }}</span>
  </div>

  <!-- Campo  de texto opcional (para observaciones)-->
  <div *ngIf="dialogData.requireInput" class="mt-3">
    <label [for]="'dialog-input'" class="block mb-2 font-medium">
      {{ dialogData.inputLabel || "Motivo" }}
      <span *ngIf="dialogData.inputRequired" class="text-red-500">*</span>
    </label>
    <textarea
      [id]="'dialog-input'"
      pInputTextarea
      [(ngModel)]="inputValue"
      [placeholder]="dialogData.inputPlaceholder || 'Ingrese el motivo'"
      [rows]="3"
      class="w-full"
      [disabled]="isLoading"
    >
    </textarea>
    <small *ngIf="showInputError" class="text-red-500 block mt-1">
      Campo obligatorio
    </small>
  </div>

  <ng-template pTemplate="footer">
    <p-button
      [label]="dialogData.rejectLabel || 'Cancelar'"
      (onClick)="onReject()"
      [disabled]="isLoading"
      [styleClass]="dialogData.rejectButtonStyleClass || 'p-button-text'"
    />
    <p-button
      [label]="dialogData.acceptLabel || 'Aceptar'"
      (onClick)="onAccept()"
      [loading]="isLoading"
      [styleClass]="dialogData.acceptButtonStyleClass || ''"
    />
  </ng-template>
</p-dialog>
